<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useImagesStore } from 'Store/pages/imageReview/imagesStore'
import { useServerStore } from 'Store/pages/imageReview/serverStore'
import { AnimatedCheckIcon } from 'Common/components/elements/icons/Icons'
import { ImageReviewStates } from 'Modules/types/generic/image/ImageReviewStates'

enum ButtonTypes {
  Info = 'info',
  Success = 'success',
  Danger = 'danger',
}

interface PropTypes {
  pushImageRoute: (imageUuid: string) => void
}

const props = defineProps<PropTypes>()

const imagesStore = useImagesStore()
const serverStore = useServerStore()
const { findNextIncomplete, findLastIncomplete } = imagesStore
const { currentImage } = storeToRefs(imagesStore)
const { handleImageReviewed } = serverStore

const isHovered = ref<boolean>(false)
const buttonType = () => {
  const isApproved = isCurentImageApproved()
  let type
  switch (true) {
    case isApproved && isHovered.value === false:
      type = ButtonTypes.Success
      break
    case isApproved && isHovered.value === true:
      type = ButtonTypes.Danger
      break
    case !isApproved && isHovered.value === false:
      type = ButtonTypes.Info
      break
    case !isApproved && isHovered.value === true:
      type = ButtonTypes.Success
      break
    default:
      return ButtonTypes.Info
  }
  return type
}
const isCurentImageApproved = () => currentImage.value?.reviewState === ImageReviewStates.Complete
const buttonText = () => {
  const isApproved = isCurentImageApproved()
  let text
  switch (true) {
    case isApproved !== true:
      text = 'Mark Reviewed'
      break
    case isApproved === true && isHovered.value === true:
      text = 'Revoke Review'
      break
    case isApproved === true && isHovered.value === false:
      text = 'Reviewed'
      break
    default:
      'Cannot be Determined'
  }

  return text
}

function handleOnMouseEnter() {
  isHovered.value = true
}

function handleOnMouseLeave() {
  isHovered.value = false
}

function handleImageReviewedClick() {
  handleImageReviewed()
  if (isCurentImageApproved() !== true) {
    const imageToCycleTo = findNextIncomplete() || findLastIncomplete()
    if (imageToCycleTo) {
      setTimeout(() => props.pushImageRoute(imageToCycleTo.imageUuid), 1000)
    }
  }
}
</script>

<template>
  <el-button
    class=""
    :type="buttonType()"
    @mouseenter="handleOnMouseEnter"
    @mouseleave="handleOnMouseLeave"
    @click="handleImageReviewedClick"
  >
    <div class="w-full flex items-center">
      <span class="h-5">
        <AnimatedCheckIcon color="teal-100" :checked="isCurentImageApproved()" />
      </span>
      <span class="w-28">
        {{ buttonText() }}
      </span>
    </div>
  </el-button>
</template>
